window.indexEndTR;
window.indexStartTD;
window.indexStartTR;
window.indexEndTD;

var currentTD;
var currentTable;
(function ($) {
    $(document).bind('editorReady', function () {
        var frameBody = $('#frameBody').get(0);
        var styleTable = $('#frameBody').contents().find('#styleTable');
        if (!styleTable.get(0)) {
            var styTable =
                '<style id="styleTable">.editorCurrent table td {border: black dotted 1px;border-collapse:collapse;border-spacing: 0;}</style>';
            //styTable ='';
            $('#frameBody').contents().find('head').append(styTable);
        }

        RVwys.currentRangeTable = false;
        RVwys.plugin['Instable'] = true;

        $('.mini_table_s').click(function () {
            $('.mini_table').eq(0).trigger('click');
            var frameBodyDoc =
                frameBody.contentWindow || frameBody.contentDocument;
            var oRVwys = frameBody != undefined ? frameBodyDoc.RVwys : RVwys;
            oRVwys.tableCell();
        });
        $('.mini_table').click(function () {
            console.log('test');
            RVwys.activeSubtoolbar('wys-elements');

            var newTable = $(
                '<table width="100%" border="0" class="uk-table" style="border-color:inherit;">' +
                    '<tbody><tr><td >&nbsp;&nbsp;&nbsp;</td>' +
                    '<td >&nbsp;&nbsp;&nbsp;</td>' +
                    '<td >&nbsp;&nbsp;&nbsp;</td></tr></tbody></table>'
            );

            if (parent.$('#Gridline').attr('act') == 'onGridline') {
                newTable = $(
                    '<div class="GridLine SelectGrid">' +
                        '<button contenteditable="false" class="Glvgn pasteButton" onclick="RVwys.cutElementGridline($(this))" title="Cut">&nbsp;</button>' +
                        '<button contenteditable="false" class="Glvgn copyButton" onclick="RVwys.copyElementGridline($(this))" title="Copy">&nbsp;</button>' +
                        '<table width="100%" border="0" class="uk-table" style="border-color:inherit;">' +
                        '<tbody><tr><td >&nbsp;&nbsp;&nbsp;</td>' +
                        '<td >&nbsp;&nbsp;&nbsp;</td>' +
                        '<td >&nbsp;&nbsp;&nbsp;</td></tr></tbody></table></div>'
                );
            }

            newTable.find('*').attr({
                designMode: 'On',
                contentEditable: 'true',
            });

            RVwys.insertHTML(newTable);
            var sel = RVwys.currentEditor.getSelection();
            sel.removeAllRanges();
            var newSel = RVwys.currentEditor.createRange();
            newSel.setStartBefore(newTable.find('th,td').eq(0).get(0));
            sel.addRange(newSel);
            // newTable.before('<div id="moveTable" class="moveTable">move</div>')
            RVwys.swDyamicToolbar(newTable);
            currentTable = newTable;
            RVwys.tableActiveToolbar(newTable);
        });

        $('.tableTextMode').click(function () {
            $('.dtbartext, .tableTextMode, .dtbartablecellprop').hide();
            $('.wys-rowTwo').find('.dtbartext').show();
            $('.tableprop').show();
            var frameBodyDoc =
                frameBody.contentWindow || frameBody.contentDocument;
            $(RVwys.currentiFrame)
                .find('.ui-selected,ui-selecting')
                .each(function () {
                    $(this).css({ backgroundColor: '' });
                    //$(this).removeClass('ui-selected')
                });

            frameBodyDoc.RVwys.unselectable();
            frameBodyDoc.RVwys.unsortable();
        });

        $('.BorderSizeTable').bind('mouseup keyup', function (e) {
            if (e.ctrlKey) {
                return true;
            }
            var oTable = currentTable;
            //alert(oTable.get(0).tagName)
            //oImg = $(frameBody.contentDocument);
            var borderVal = $(this).val().match('^\\d+$');

            if (borderVal != 0) {
                oTable.css({
                    borderWidth: borderVal + 'px;',
                    borderCollapse: 'initial',
                    borderSpacing: 'initial',
                });
                if (
                    oTable.get(0).style.borderStyle == '' ||
                    oTable.get(0).style.borderStyle == 'none'
                ) {
                    oTable.get(0).style.borderStyle = 'solid';
                }
            } else {
                $('.BorderSizeTable').val('');
                oTable.css({
                    borderWidth: '',
                    borderCollapse: '',
                    borderSpacing: '',
                });
                oTable.get(0).style.borderStyle = '';
                var borderStyle = 'none';
            }
            oTable.attr('border', borderVal);
            borderStyle = oTable.get(0).style.borderStyle;
            $('.BorderStyleTable dt a span').html(borderStyle);
        });

        $('.BorderStyleTable dd ul li a').click(function () {
            var oTable = currentTable;
            var text = $(this).find('span').eq(0).html();
            if (text == 'None') {
                oTable.attr('border', '0');
                $('.BorderSizeTable').val('');
            }
            $('.BorderStyleTable dt a span').html(text);
            oTable.get(0).style.borderStyle = text;

            $('.BorderStyleTable dd ul').hide();
        });

        $('.BorderColorTable').spectrum({
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'hex',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $('#set-blockProperties').spectrum('revert');
                });
                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
            },
            move: function (color) {
                RVwys.setBorderTableColor(color);
            },

            hide: function (color) {
                RVwys.setBorderTableColor(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);

                $(RVwys.currentiFrame).focus();
            },
        });

        $('.BorderStyleTable dd ul li a').click(function () {
            var rangeParent = RVwys.getRangeParent();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var text = $(this).find('span').eq(0).html();

            $('.BorderStyleTable dt a span').html(text);
            oTable.css('border-style', text);

            $('.BorderStyleTable dd ul').hide();
        });

        $('.tableAlign dd ul li a').click(function () {
            var rangeParent = RVwys.getRangeParent();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var text = $(this).find('span').eq(0).html();
            $('.tableAlign dt a span').html(text);
            oTable.attr('align', text);
            $('.tableAlign dd ul').hide();
        });

        $('.tableWidth').bind('mouseup keyup', function (e) {
            //alert(currentTable)
            //var rangeParent = RVwys.getRangeParentNotFocus();
            //var oTable = RVwys.getParentTable(rangeParent,'table');
            if (e.ctrlKey) {
                return true;
            }
            // $(".tableWidth").val($(this).val());
            var oTable = currentTable;
            if ($('.tableWidthPX dt a span').eq(0).text() == 'px') {
                oTable.attr(
                    'width',
                    $(this).val() + $('.tableWidthPX dt a span').text()
                );
            } else {
                oTable.attr('width', $(this).val() + '%');
            }
            oTable.css({
                width: $(this).val() + $('.tableWidthPX dt a span').text(),
            });
        });
        $('.tableWidthPX dd ul li a').click(function () {
            var oTable = currentTable;
            var text = $(this).find('span').eq(0).html();

            $('.tableWidthPX dt a span').html(text);
            oTable.attr('width', $('#tableWidth').val() + $(this).text());
            oTable.css({ width: $('#tableWidth').val() + $(this).text() });
            $('.tableWidthPX dd ul').hide();
        });
        $('.ColorTable').spectrum({
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'hex',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $('#set-blockProperties').spectrum('revert');
                });
                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
            },
            move: function (color) {
                RVwys.setTableColor(color);
            },

            hide: function (color) {
                RVwys.setTableColor(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);

                $(RVwys.currentiFrame).focus();
            },
        });
        /*

    $('.ColorTable').click(function(){
        var oTable = currentTable;

        var offset = $(this).offset();
        objColorpicker =  $('#colorpickerTool');
        var lw = offset.left+objColorpicker.width();
        offsetLeft = (lw>$(window).width()) ?offset.left-(lw- $(window).width()):offset.left;
        objColorpicker.offset({ top: offset.top+$(this).height()+10, left: offsetLeft});
        objColorpicker.draggable({cancel:"#colorpickerHolderCustom"});
        objColorpicker.show();

         $.fn.colorPickerInsert = function(color){
             oTable.attr('bgcolor', "#"+color);
             oTable.css("backgroundColor", "#"+color);
             objColorpicker.offset({ top: 0, left: 0}).hide();
         };

         $.fn.colorPickerCancel = function(){
        	 objColorpicker.offset({ top: 0, left: 0}).hide();
         };
         //cloneRange = RVwys.getRange();

        //tagParent.find('img').wrap($("<a>").attr("href", $('#wys-imageLink').val()));

    });
    */
        $('.tdTable').click(function () {
            var rangeParent =
                $(this).attr('cmd') == 'before'
                    ? RVwys.pointerTable('first')
                    : RVwys.pointerTable('last');
            //alert(rangeParent.get(0).tagName)
            var thisIndex = rangeParent.index();
            var vaildTagTable = { td: true, th: true };
            var keyTag = rangeParent.get(0).tagName.toLowerCase();

            if (vaildTagTable[keyTag]) {
                var oTR = RVwys.getParentTable(rangeParent, 'tr');
                var newTR = $('<tr></tr>');
                oTR.find('th,td').each(function () {
                    var newColunm = $(
                        '<' + keyTag + '> &nbsp;&nbsp;&nbsp;</' + keyTag + '>'
                    )
                        .addClass('ui-selectee')
                        .attr({
                            width: $(this).attr('width'),
                            bgcolor: $(this).attr('bgcolor'),
                        });
                    newTR.append(newColunm);
                });
                if ($(this).attr('cmd') == 'before') {
                    oTR.before(newTR);
                } else {
                    oTR.after(newTR);
                }
                /*
         var sel = RVwys.currentEditor.getSelection();
         //sel.removeAllRanges();
         newSel = RVwys.currentEditor.createRange();
         newSel.setStartBefore(newTR.find('*').eq(thisIndex).get(0));
         sel.addRange(newSel);
         */
                $(RVwys.currentiFrame).focus();
                RVwys.regisTable();
            }
        });

        $('.trTable').click(function () {
            RVwys.activeSubtoolbar('wys-elements');
            var cmd = $(this).attr('cmd');
            var rangeParent =
                cmd == 'before'
                    ? RVwys.pointerTable('first')
                    : RVwys.pointerTable('last');
            //rangeParent = RVwys.pointerTable();
            var thisTD = rangeParent;
            var thisTR = rangeParent.parent();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var fixIndexTD = thisTD.index();
            oTable.find('tr').each(function () {
                //alert(thisTD.index())
                var colunmTH = $(this).find('th').eq(fixIndexTD);

                var colunm =
                    colunmTH.length != 0
                        ? colunmTH
                        : $(this).find('th,td').eq(fixIndexTD);
                var colunmTag = colunm.get(0).tagName.toLowerCase();

                var newTd = $(
                    '<' + colunmTag + '>&nbsp;&nbsp;&nbsp;</' + colunmTag + '>'
                )
                    .addClass('ui-selectee')
                    .attr({
                        bgcolor: colunm.attr('bgcolor'),
                        width: colunm.attr('width'),
                    });

                if (cmd == 'before') {
                    colunm.before(newTd);
                } else {
                    colunm.after(newTd);
                }
            });
            $(RVwys.currentiFrame).focus();
            RVwys.regisTable();
        });

        //rmTable
        $('.rmTable').click(function () {
            var rangeParent = RVwys.getRangeParent();

            var oTable = RVwys.getParentTable(rangeParent, 'table');
            if (oTable) {
                oTable.remove();
            }

            $(RVwys.currentiFrame).focus();
            var newRangeParent = RVwys.getRangeParent();
            RVwys.swDyamicToolbar(newRangeParent);
            RVwys.regisTable();
        });

        $('.rmTD').click(function () {
            var rangeParent = RVwys.pointerTable();

            var indexTD = rangeParent.index();
            var indexTR = rangeParent.parent().index();
            var oTable = RVwys.getParentTable(rangeParent, 'table');

            if (oTable.find('tr').length == oTable.find('th,td').length) {
                oTable.remove();
                $(RVwys.currentiFrame).focus();
                var newRangeParent = RVwys.getRangeParent();
                RVwys.swDyamicToolbar(newRangeParent);
                parent
                    .$('#frameBody')
                    .contents()
                    .find('.overlaytable')
                    .remove();
                RVwys.selectableEnableState();
            } else {
                if (oTable) {
                    oTable.find('tr').each(function () {
                        $(this).find('td').eq(indexTD).remove();
                        $(this).find('th').eq(indexTD).remove();
                    });
                    currentTD = oTable
                        .find('tr')
                        .eq(indexTR)
                        .find('th,td')
                        .eq(indexTD - 1);
                    if (currentTD.get(0)) {
                        currentTD.addClass('ui-selected');
                        RVwys.addRangeTable(currentTD);
                    }
                }
            }

            $(RVwys.currentiFrame).focus();
            RVwys.regisTable();
        });

        $('.rmTR').click(function () {
            var rangeParent = RVwys.pointerTable();
            var oTR = RVwys.getParentTable(rangeParent, 'tr');
            var indexTD = rangeParent.index();
            var indexTR = oTR.index();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var countTR = 0;
            oTable.find('tr').each(function () {
                countTR++;
            });
            if (oTR) {
                oTR.remove();
            }
            //alert(countTR)
            if (countTR == 1) {
                oTable.remove();
                $(RVwys.currentiFrame).focus();
                var newRangeParent = RVwys.getRangeParent();
                RVwys.swDyamicToolbar(newRangeParent);
                RVwys.selectableEnableState();
                parent
                    .$('#frameBody')
                    .contents()
                    .find('.overlaytable')
                    .remove();
            } else {
                currentTD = oTable
                    .find('tr')
                    .eq(indexTR - 1)
                    .find('th,td')
                    .eq(indexTD);
                currentTD.addClass('ui-selected');
                RVwys.addRangeTable(currentTD);
                RVwys.swDyamicToolbar(currentTD);
            }
            $(RVwys.currentiFrame).focus();
            RVwys.regisTable();
        });

        $('.colorCellTable').spectrum({
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'hex',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $('#set-blockProperties').spectrum('revert');
                });
                $(RVwys.currentiFrame).bind('keydown', RVwys.unkeydown);
                var rangeParent = RVwys.pointerTable();
            },
            move: function (color) {
                RVwys.setTableCellColor(color);
            },

            hide: function (color) {
                RVwys.setTableCellColor(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
                $(RVwys.currentiFrame).unbind('keydown', RVwys.unkeydown);

                $(RVwys.currentiFrame).focus();
            },
        });
        /*
 $('.colorCellTable').click(function(){
	 //alert('s')
     rangeParent = RVwys.pointerTable();
	 //alert('s1')
     //var oTR = RVwys.getParentTable(rangeParent,'tr');
     $('#colorpickerToolCancel').val('close');
     var offset = $(this).offset();
     var notClickRecent = true;

     cmd = $(this).attr('cmd');
     objColorpicker =  $('#colorpickerTool');
     var lw = offset.left+objColorpicker.width();
     offsetLeft = (lw>$(window).width()) ?offset.left-(lw- $(window).width()):offset.left;

     objColorpicker.offset({ top: offset.top+$(this).height()+10, left: offsetLeft});
     objColorpicker.draggable({cancel:"#colorpickerHolderCustom"});
     if(!objColorpicker.is(':visible')) {
         objColorpicker.show();
     }
     $.fn.colorPickerInsert = function(color){
        // var rangeParent = RVwys.getRangeParent();
        if(color) {
            color = '#'+color;
        }
         oTable = RVwys.getParentTable(RVwys.currentRangeTable,'table');
         oTable.find('.ui-selected').each(function(){

             $(this).attr('bgcolor',color).css({'backgroundColor':color})
             //$(this).removeClass('ui-selected')
         })
         if(rangeParent.get(0).tagName.toLowerCase() == 'td') {

            // rangeParent.attr('bgcolor',color);
             //$(RVwys.currentiFrame).focus();
         }
         objColorpicker.offset({ top: 0, left: 0}).hide();
     };

     $.fn.colorPickerCancel = function(){
         frameBodyDoc = (frameBody.contentWindow || frameBody.contentDocument);

         $(RVwys.currentiFrame).find('.ui-selected').each(function(){
             $(this).css({'backgroundColor':''})
             //$(this).removeClass('ui-selected')
         })
        // frameBodyDoc.RVwys.unselectable();
         objColorpicker.offset({ top: 0, left: 0}).hide();
     };

     cloneRange = RVwys.getRange();
});
*/
        $('.moveTable').click(function () {
            var rangeParent = RVwys.getRangeParent();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var sel = RVwys.currentEditor.getSelection();
            sel.removeAllRanges();
            var newSel = RVwys.currentEditor.createRange();
            newSel.selectNode(oTable.get(0));
            sel.addRange(newSel);
            var frameBodyDoc =
                frameBody.contentWindow || frameBody.contentDocument;
            frameBodyDoc.RVwys.unselectable();
            frameBodyDoc.RVwys.unsortable();
            $(RVwys.currentiFrame).css({ cursor: 'move' });
            $(RVwys.currentiFrame)
                .find('.ui-selected')
                .each(function () {
                    $(this).css({ backgroundColor: '' });
                    //$(this).removeClass('ui-selected')
                });
        });

        $('.sortableRow').click(function () {
            var frameBodyDoc =
                frameBody.contentWindow || frameBody.contentDocument;
            frameBodyDoc.RVwys.sortableRow();
            $(RVwys.currentiFrame)
                .find('.ui-selected')
                .removeClass('ui-selected');
        });

        $('.sortableCol').click(function () {
            frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
            frameBodyDoc.RVwys.sortableCol();
        });

        //selectMergeTable
        $('.selectMergeTable').click(function () {
            var rangeParent = RVwys.pointerTable();
            var oTable = RVwys.getParentTable(rangeParent, 'table');
            var tdSelected = oTable.find('.ui-selected');
            if (tdSelected.length > 1) {
                var tableColunm = 0;
                var colunmSpanCount = 0;
                var tdFrist = tdSelected.first();
                var tdLast = tdSelected.last();
                var i = 0;
                colSpan = tdFrist.attr('colspan') ? tdFrist.attr('colspan') : 1;
                rowSpan = tdFrist.attr('rowspan') ? tdFrist.attr('rowspan') : 1;

                rowSpan =
                    Math.abs(
                        parseInt(tdFrist.parent().index()) -
                            parseInt(tdLast.parent().index())
                    ) + 1;
                tdSelected.each(function () {
                    if (i != 0) {
                        var currentTR = $(this).parent();
                        if (currentTR.index() == tdFrist.parent().index()) {
                            colSpan = $(this).attr('colspan')
                                ? parseInt(colSpan) +
                                  parseInt($(this).attr('colspan'))
                                : parseInt(colSpan) + 1;
                        }
                        tdFrist.append($(this).html());
                        $(this).remove();
                        if (currentTR.find('th,td').length == 0) {
                            currentTR.remove();
                        }
                    }
                    i++;
                });
                tdFrist.attr('colspan', colSpan);
                if (rowSpan > 1) {
                    tdFrist.attr('rowspan', rowSpan);
                }
                indexCurTD = tdFrist.index();
                countCurTD = tdFrist.parent().find('th,td').length;

                oClearTD = [];
                var i = 0;
                countTR = oTable.find('tr').each(function () {
                    if (
                        $(this).find('th,td').eq(indexCurTD) &&
                        $(this).find('th,td').eq(indexCurTD).attr('colspan') &&
                        $(this).find('th,td').eq(indexCurTD).attr('colspan') ==
                            colSpan &&
                        $(this).find('th,td').length == countCurTD
                    ) {
                        oClearTD[i] = $(this).find('th,td').eq(indexCurTD);
                        i++;
                    }
                }).length;

                if (countTR == oClearTD.length) {
                    $.each(oClearTD, function (i, o) {
                        oClearTD[i].removeAttr('colspan');
                    });
                }
                RVwys.regisTable();
            }
        });
        // select image
        //$()

        // select image
        $('.reSelectThis').click(function () {
            var rangeParent = RVwys.getRangeParent();
            var sel = RVwys.currentEditor.getSelection();
            sel.removeAllRanges();
            var newSel = RVwys.currentEditor.createRange();
            newSel.selectNode(rangeParent.get(0));
            sel.addRange(newSel);
            frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
            frameBodyDoc.RVwys.unselectable();
            frameBodyDoc.RVwys.unsortable();
            $(RVwys.currentiFrame).css({ cursor: 'move' });
            $(RVwys.currentiFrame)
                .find('.ui-selected')
                .each(function () {
                    $(this).css({ backgroundColor: '' });
                });
        });

        //tdValign
        $('.tdValign').click(function () {
            var rangeParent = RVwys.pointerTable();
            var oTable = RVwys.getParentTable(RVwys.currentRangeTable, 'table');

            var oThisBtn = $(this);
            oTable.find('.ui-selected').each(function () {
                $(this).attr('valign', oThisBtn.attr('cmd')); //.css({'backgroundColor':color})
                //$(this).removeClass('ui-selected')
            });
        });

        $('.tdAlign').click(function () {
            var rangeParent = RVwys.pointerTable();
            var oTable = RVwys.getParentTable(RVwys.currentRangeTable, 'table');

            var oThisBtn = $(this);
            oTable.find('.ui-selected').each(function () {
                $(this).attr('align', oThisBtn.attr('cmd')); //.css({'backgroundColor':color})
                //$(this).removeClass('ui-selected')
            });
        });
    });

    RVwys.designViewAddEvent('mouseup', function (e) {
        if (
            $(e.target).get(0) &&
            ($(e.target).get(0).tagName.toLowerCase() == 'td' ||
                $(e.target).get(0).tagName.toLowerCase() == 'th')
        ) {
            RVwys.tableActiveToolbar($(e.target));
            var oTable = RVwys.getParentTable($(e.target), 'table');
            currentTable = oTable;
        }
    });

    RVwys.setTableCellColor = function (color) {
        var rangeParent = RVwys.getRangeParent();
        var oTable = RVwys.getParentTable(rangeParent, 'table');
        oTable.find('.ui-selected').each(function () {
            if (color == null) {
                $(this).removeAttr('bgcolor');
                $(this).css('backgroundColor', '');
            } else {
                $(this)
                    .attr('bgcolor', color)
                    .css({ backgroundColor: color.toHexString() });
            }
            //$(this).removeClass('ui-selected')
        });
    };

    RVwys.setTableColor = function (color) {
        console.log('table color' + color);
        var rangeParent = RVwys.getRangeParent();
        var oTable = RVwys.getParentTable(rangeParent, 'table');
        if (color == null) {
            oTable.removeAttr('bgcolor');
            oTable.css('backgroundColor', '');
        } else {
            oTable.attr('bgcolor', '#' + color);
            oTable.css('backgroundColor', color.toHexString());
        }
    };
    RVwys.setBorderTableColor = function (color) {
        var rangeParent = RVwys.getRangeParent();
        var oTable = RVwys.getParentTable(rangeParent, 'table');
        console.log('table borderColor' + color);
        oTable.css('borderColor', color);
        if (color == null) {
            oTable.css('borderColor', '');
        } else {
            oTable.css('borderColor', color);
        }
    };
    RVwys.tableActiveToolbar = function (eTarget) {
        if (eTarget.get(0)) {
            if (
                eTarget.get(0).tagName.toLowerCase() == 'table' ||
                eTarget.get(0).tagName.toLowerCase() == 'td' ||
                eTarget.get(0).tagName.toLowerCase() == 'th'
            ) {
                var eTable =
                    eTarget.get(0).tagName.toLowerCase() == 'td'
                        ? eTarget.parent()
                        : eTarget;
                eTable =
                    eTable.get(0).tagName.toLowerCase() == 'th'
                        ? eTable.parent()
                        : eTable;
                eTable =
                    eTable.get(0).tagName.toLowerCase() == 'tr'
                        ? eTable.parent()
                        : eTable;
                eTable =
                    eTable.get(0).tagName.toLowerCase() == 'tbody'
                        ? eTable.parent()
                        : eTable;

                //talble algin
                if (
                    eTable.attr('align') != undefined &&
                    eTable.attr('align') != 'left'
                ) {
                    parent
                        .$('.tableAlign dt a span')
                        .html(eTable.attr('align'));
                } else {
                    parent.$('.tableAlign dt a span').html('left');
                }
                //border
                if (eTable.attr('border') && eTable.attr('border') != 0) {
                    parent.$('.BorderSizeTable').val(eTable.attr('border'));
                } else {
                    parent.$('.BorderSizeTable').attr('value', '');
                }
                //BorderStyle

                if (eTable.get(0).style.borderStyle) {
                    parent
                        .$('.BorderStyleTable dt a span')
                        .html(eTable.get(0).style.borderStyle);
                } else {
                    parent.$('.BorderStyleTable dt a span').html('None');
                }

                //table width

                if (eTable.attr('style')) {
                    var patt = /width\:([^:]*?)\;/gim;
                    var styleWdith = patt.exec(eTable.attr('style'));

                    var thisWidth = '0';

                    if (styleWdith) {
                        thisWidth = styleWdith[1];
                    } else {
                        if (eTable.attr('width') != 0) {
                            thisWidth = eTable.attr('width');
                        }
                    }
                    var thisWidthPX = thisWidth.match(/\%/gim) ? '%' : 'px';
                    parent.$('.tableWidthPX dt a span').html(thisWidthPX);
                } else {
                    thisWidth = eTable.attr('width');
                    var thisWidthPX = thisWidth.match(/\%/gim) ? '%' : 'px';
                    parent.$('.tableWidthPX dt a span').html(thisWidthPX);
                }
                parent.$('.tableWidth').val(parseInt(thisWidth));
            }
        }
    };
    RVwys.addRangeTable = function (obj) {
        frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
        frameBodyDoc.RVwys.currentRangeTable = obj;
        RVwys.currentRangeTable = obj;
    };
    RVwys.sortableRow = function () {
        this.unsortable();
        this.unselectable();
        this.statusSortMode();
        var fixWidth = function (e, tr) {
            var $originals = tr.children();
            var $helper = tr.clone();
            $helper.children().each(function (index) {
                $(this).width($originals.eq(index).width());
            });
            return $helper;
        };
        rvSortable = $('tbody')
            .sortable({
                helper: fixWidth,
                cursor: 'move',
                axis: 'y',
                start: function () {
                    $(RVwys.currentiFrame)
                        .find('.ui-selected')
                        .removeClass('ui-selected');
                    var sel = RVwys.currentEditor.getSelection();
                    sel.removeAllRanges();
                },
            })
            .find('th,td')
            .addClass('moveBlock');
    };
    RVwys.sortableCol = function () {
        this.unsortable();
        this.unselectable();
        this.statusSortMode();
        var fixWidth = function (e, tr) {
            var $originals = tr.children();
            var $helper = tr.clone();
            $helper.children().each(function (index) {
                $(this).width($originals.eq(index).width());
            });
            return $helper;
        };
        rvSortable = $('tbody')
            .find('tr')
            .sortable({
                helper: fixWidth,
                cursor: 'move',
                axis: 'x',
                start: function (event, ui) {
                    var td = false;

                    $(this)
                        .find('th,td')
                        .each(function () {
                            if ($(this).is(':hidden')) {
                                var td = $(this);
                                td.addClass('drag-helper');
                                tdIndex = td.index();
                            }
                        });
                    $(this)
                        .parent()
                        .find('tr')
                        .each(function () {
                            objTD = $(this).find('th,td').eq(tdIndex).clone();
                            objTD
                                .css({
                                    display: 'table-cell',
                                    position: 'absolute',
                                    zIndex: 1000,
                                })
                                .addClass('ui-sortable-helpers');
                            $(this).append(objTD);
                        });
                    RVwys.cloneUiSortablePlaceholder($(this), tdIndex, 'start');
                },
                stop: function (event, ui) {
                    var indexTR = $(this).index();
                    $(this)
                        .parent()
                        .find('tr')
                        .each(function () {
                            mainTd = $(this).find('.main');
                            mainTd.removeClass('main');
                            if ($(this).index() != indexTR) {
                                mainTd.show();
                                $(this)
                                    .find('.ui-sortable-placeholder')
                                    .replaceWith(mainTd);

                                $(this)
                                    .find('.ui-sortable-placeholder')
                                    .remove();
                            }
                        });
                    $('.ui-sortable-helpers').remove();
                },
                change: function (event, ui) {
                    var trIndex = $(this).index();
                    $(this)
                        .parent()
                        .find('tr')
                        .each(function () {
                            if ($(this).index() != trIndex) {
                                $(this)
                                    .find('.ui-sortable-placeholder')
                                    .remove();
                            }
                        });
                    var PIndex = $(this)
                        .find('.ui-sortable-placeholder')
                        .index();
                    RVwys.cloneUiSortablePlaceholder($(this), PIndex, 'change');
                },
                sort: function (event, ui) {
                    var oTD = $('.ui-sortable-helper');
                    $('.ui-sortable-helpers').css({
                        left: oTD.position().left,
                        width: oTD.width(),
                    });
                },
            })
            .find('th,td')
            .addClass('moveBlock');
    };

    RVwys.cloneUiSortablePlaceholder = function (obj, tdIndex, event) {
        var indexTR = $(obj).index();
        $(obj)
            .parent()
            .find('tr')
            .each(function () {
                if (indexTR != $(this).index()) {
                    if (event == 'start') {
                        $(this)
                            .find('th,td')
                            .eq(tdIndex)
                            .addClass('main')
                            .hide();
                    }
                    if (
                        $(this).find('.ui-sortable-placeholder').get(0) ==
                        undefined
                    ) {
                        var clonePlaceholder = $('.ui-sortable-placeholder')
                            .eq(0)
                            .clone();

                        if (tdIndex > 0) {
                            // tdIndex=tdIndex-1;
                            if (
                                $(this)
                                    .find('th,td')
                                    .eq(tdIndex - 1)
                                    .get(0)
                            ) {
                                $(this)
                                    .find('th,td')
                                    .eq(tdIndex - 1)
                                    .after(clonePlaceholder);
                            }
                        } else {
                            if ($(this).find('th,td').eq(tdIndex).get(0)) {
                                $(this)
                                    .find('th,td')
                                    .eq(tdIndex)
                                    .before(clonePlaceholder);
                            }
                        }
                    }
                }
            });
    };

    RVwys.designViewAddEvent('mousedown', function (e) {});

    RVwys.designViewAddEvent('keydown', function (e) {});

    RVwys.addStatusTable = function (eleTarget) {
        if (typeof eleTarget.toLowerCase() == 'object') {
            if ($('.statusTableTools').get(0)) {
                $('.statusTableTools').empty();
                $('.statusTableTools').append(eleTarget);
            } else {
                parent.$('.statusTableTools').empty();
                parent.$('.statusTableTools').append(eleTarget);
            }
        } else {
            if ($('.statusTableTools').get(0)) {
                $('.statusTableTools').html();
                $('.statusTableTools').html(eleTarget);
            } else {
                parent.$('.statusTableTools').html();
                parent.$('.statusTableTools').html(eleTarget);
            }
        }
    };
    RVwys.statusSortMode = function () {
        this.addStatusTable(parent.$('.actionSortable').html());
        parent.$('.sortableOff').click(function () {
            RVwys.unsortable();
            RVwys.selectable();
            RVwys.statusSelectMode();
            RVwys.regisTable();
        });
        parent.$('.tableTextMode').click(function () {
            //   	 alert('start 2 tableTextMode')
            //         parent.$('.dtbartext').hide();
            //         parent.$('.wys-rowTwo').find('.dtbartext').show();
            //         parent.$('.dtbartableprop').show();
            //         parent.$('.dtbartableCell').show();
            //         parent.$('.dtbartablecellprop').hide();
            //         parent.$('.tableTextMode').hide();

            parent.$('.wys-rowTwo').find('.dtbartext').show();
            parent.$('.dynamictools').find('.dtbartext').hide();
            parent.$('.tableprop').show();
            parent.$('.dtbartablecellprop,.tableTextMode').hide();
            //tableprop
            RVwys.statusTableMode();
            $(RVwys.currentiFrame)
                .find('.ui-selected')
                .each(function () {
                    $(this).css({ backgroundColor: '' });
                    //$(this).removeClass('ui-selected')
                });

            RVwys.unselectable();
            RVwys.unsortable();
        });
    };

    RVwys.tableText = function () {
        //parent.$('.wys-rowTwo').find('.dtbartext').show();
        //parent.$('.dtbartext').show();
        console.log('tableMode =' + tableMode);
        if (tableMode) {
            parent.$('.dtbartext').show();
        }
        tableMode = false;
        parent.$('.tableTextMode').hide();
        parent.$('.dtbartablecellprop').hide();
        $('.overlaytable').remove();
        //parent.$('.main-panel').find('.dtbartext').show();
        RVwys.selectableEnableState();
        $('.RVWYSIWYGAREA')
            .attr('contenteditable', 'true')
            .find('*[contenteditable="false"]')
            .attr('contenteditable', 'true');
        RVwys.statusTableMode();
        $(RVwys.currentiFrame)
            .find('.ui-selected')
            .each(function () {
                $(this).css({ backgroundColor: '' });
                $(this).removeClass('ui-selected');
            });
        // $(RVwys.currentiFrame).focus();
        frameBody = parent.$('#frameBody').get(0);
        RVwys.unresizeTable();
        $(RVwys.currentiFrame)
            .find('table')
            .each(function () {
                if ($(this).hasClass('ui-selectable')) {
                    $(this).selectable('destroy');
                    $('.ui-selectable-helper').remove();
                }
            })
            .end()
            .find('.ui-selected')
            .removeClass('ui-selected')
            .end()
            .find('.ui-selectee')
            .removeClass('ui-selectee');
        RVwys.unregisTable();
        $('.ui-selectee').unbind('mouseover');

        parent.$('.mode-element').tabs('option', 'active', 0);
    };

    RVwys.tableCell = function () {
        tableMode = true;
        parent.$('#msgTable').hide();
        var newRangeParent = RVwys.getRangeParent();
        var thisTable = RVwys.getParentTable(newRangeParent, 'table');
        if (!thisTable) {
            parent.$('#msgTable').show();
            tableMode = false;
            return false;
        }

        RVwys.selectableEnableState();
        frameBody = $('#frameBody').get(0);
        if (frameBody != undefined) {
            frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
            var oRVwys = frameBodyDoc.RVwys;
        } else {
            var oRVwys = RVwys;
        }
        $('.ui-selectable-helper').remove();

        oRVwys.selectable();
        //     parent.$('.dtbartableCell').show();
        parent.$('.dtbartablecellprop,.dtbartableprop,.tableTextMode').show();
        parent.$('.dtbartable,.dtbartext,.dtbarimage').hide();
        parent.$('.overlaytable').remove();
        var overlaypanel = $('<div class="overlaytable"></div>')
            .css({
                width: $('body').width(),
                height: $('body').height(),
                'z-index': '99',
            })
            .click(function () {
                //alert('s');
                //$(this).remove();
                RVwys.tableText();
                $('.currentEditTABLE').removeClass('currentEditTABLE');
            });
        $('body').prepend(overlaypanel);
        var rangeParent = RVwys.getRangeParent();
        var oTable = RVwys.getParentTable(rangeParent, 'table');
        oTable.find('*[contenteditable]').attr('contenteditable', 'false');

        $('.RVWYSIWYGAREA')
            .css({ 'z-index': 'none' })
            .attr('contenteditable', 'false');
        $('.currentEditTABLE').removeClass('currentEditTABLE');
        oTable.closest('.RVWYSIWYGAREA').parent().addClass('currentEditTABLE');
    };
    RVwys.statusSelectMode = function () {
        this.addStatusTable(parent.$('.actionSelectable').html());
        parent.$('.tableTextMode').click(function () {
            RVwys.tableText();
        });
    };

    RVwys.statusTableMode = function () {
        this.addStatusTable(parent.$('.actiontable').html());
        parent.$('.tableprop').show();
        parent.$('.tableprop').click(function () {
            RVwys.tableCell();
        });
    };

    RVwys.unregisTable = function () {
        $(RVwys.currentiFrame)
            .find('th,td')
            .each(function () {
                if ($(this).attr('indextr')) {
                    $(this).removeAttr('indextr');
                    $(this).removeAttr('indextd');
                }
            });
    };

    RVwys.regisTable = function () {
        this.unregisTable();
        $(RVwys.currentiFrame)
            .find('table')
            .each(function () {
                var nextIndexTD = 0;
                var rollRowSpan = 0;
                var rollColSpan = 0;
                $(this)
                    .find('tr')
                    .each(function () {
                        var indextd = 0;
                        var indextr = $(this).index() + 1;
                        $(this)
                            .find('th,td')
                            .each(function () {
                                indextd = $(this).attr('colspan')
                                    ? indextd +
                                      parseInt($(this).attr('colspan'))
                                    : indextd + 1;
                                //indextr = ($(this).attr('rowspan'))? indextr+parseInt($(this).attr('rowspan')):$(this).parent().index();
                                if (rollRowSpan > 1 && indextd == nextIndexTD) {
                                    indextd = indextd + rollColSpan;
                                    rollRowSpan--;
                                }
                                if ($(this).attr('rowspan')) {
                                    indextr =
                                        indextr +
                                        (parseInt($(this).attr('rowspan')) - 1);
                                    // indexTd-colspan +1 = next index td  rowspan
                                    rollRowSpan = parseInt(
                                        $(this).attr('rowspan')
                                    );

                                    if ($(this).attr('colspan')) {
                                        nextIndexTD =
                                            indextd -
                                            parseInt($(this).attr('colspan')) +
                                            1;
                                        rollColSpan = parseInt(
                                            $(this).attr('colspan')
                                        );
                                    } else {
                                        nextIndexTD = indextd;
                                        rollColSpan = 1;
                                    }
                                    nextIndexTD = $(this).attr('colspan')
                                        ? indextd -
                                          parseInt($(this).attr('colspan')) +
                                          1
                                        : indextd;
                                } else {
                                    indextr = $(this).parent().index() + 1;
                                }

                                $(this).attr({
                                    indextr: indextr,
                                    indextd: indextd,
                                });
                            });
                    });
            });
    };
    RVwys.reSelectingTable = function (event, ui) {
        var inREnd = parseInt($(ui.selecting).attr('indextr'));
        if ($(ui.selecting).attr('indextr') > indexEndTR) {
            indexEndTR = parseInt($(ui.selecting).attr('indextr'));
            inREnd = indexEndTR;
        }

        var row = 1;
        if ($(ui.selecting).attr('rowspan')) {
            row = parseInt($(ui.selecting).attr('rowspan'));
        }

        var inRStart = inREnd - row;
        //$('#mouseXY').append('inRStart- '+inRStart);
        if (inRStart < indexStartTR) {
            indexStartTR = inRStart;
        }
        var inEnd;
        if ($(ui.selecting).attr('indextd') > indexEndTD) {
            indexEndTD = parseInt($(ui.selecting).attr('indextd'));
            inEnd = indexEndTD;
        } else {
            inEnd = parseInt($(ui.selecting).attr('indextd'));
        }
        var col;
        if ($(ui.selecting).attr('colspan')) {
            col = parseInt($(ui.selecting).attr('colspan'));
        } else {
            col = 1;
        }

        var inStart = inEnd - col;
        //$('#mouseXY').append('inStart- '+$(ui.selecting).attr('indextd')+indexEndTD);
        if (inStart < indexStartTD) {
            indexStartTD = inStart;
        }
        // $('#mouseXY').append('s-('+indexStartTD+','+indexEndTD+')');
        //$('#mouseXY').append('s-('+indexStartTR+','+indexEndTR+')');

        //olspan = $(ui.selecting).attr('colspan');
        RVwys.loopSelecting(event);
    };

    RVwys.loopSelecting = function (event) {
        return false;
    };

    RVwys.pointerTable = function (stVal) {
        //:first ||:last
        var frameBodyDoc = frameBody.contentWindow || frameBody.contentDocument;
        // frameBodyDoc.RVwys.unsortable();
        //('pointerTable2')
        //frameBodyDoc.RVwys.selectable();
        // alert('pointerTable3')
        RVwys.activeSubtoolbar('wys-elements');

        switch (stVal) {
            case 'first':
                return $(this.currentiFrame).find('.ui-selected').first();
            case 'last':
                return $(this.currentiFrame).find('.ui-selected').last();
            default:
                var rangeParent =
                    this.currentRangeTable && this.currentRangeTable.get(0)
                        ? this.currentRangeTable
                        : $(this.currentiFrame).find('.ui-selected');
                if (rangeParent.get(0) == undefined) {
                    rangeParent = $(RVwys.currentiFrame)
                        .find('.ui-selectee')
                        .eq(0)
                        .addClass('ui-selected');
                }
                return rangeParent;
        }
    };

    RVwys.unsortable = function () {
        try {
            $('tbody').sortable('destroy');
        } catch (e) {
            console.log(e);
        }
        try {
            $('tbody').find('tr').sortable('destroy');
        } catch (e) {
            console.log(e);
        }
        $('.moveBlock').removeClass('moveBlock');
    };
    RVwys.resizeObject = {
        handles: 'e, s',
        create: function (event, ui) {
            /*
                 if($.browser.mozilla) {
                     $(event.target).parent().find('.ui-resizable-e').height($(event.target).height())
                     $('td').each(function(){
                         $(this).find('.ui-resizable-e').css({
                                 width:'10px'
                                  ,height:$(this).height()
                                  ,left:$(this).width()+$(this).position().left
                                  ,top:$(this).position().top
                              });

                         $(this).find('.ui-resizable-s').css({
                                 width:$(this).width()
                                  ,height:'10px'
                                  ,left:$(this).position().left
                                  ,top:$(this).height()+$(this).position().top
                              });

                     });
                 }

                 if($.browser.webkit) {
                     $(event.target).parent().find('.ui-resizable-e').width('7')
                     $(event.target).parent().find('.ui-resizable-s').height('7')
                     /*
                     alert($(event.target).height())
                     $(event.target).parent().find('.ui-resizable-e').height($(event.target).height())
                     $('td').each(function(){
                         $(this).find('.ui-resizable-e').css({
                                 width:'10px'
                                  ,height:$(this).height()
                                  ,left:$(this).width()+$(this).position().left
                                  ,top:$(this).position().top
                              });

                         $(this).find('.ui-resizable-s').css({
                                 width:$(this).width()
                                  ,height:'10px'
                                  ,left:$(this).position().left
                                  ,top:$(this).height()+$(this).position().top
                              });

                     })

                 }
 */
            $(event.target).parent().find('.ui-resizable-e').width('7');
            $(event.target).parent().find('.ui-resizable-s').height('7');
        },
        resize: function (event, ui) {
            var width = ui.size.width;
            var height = ui.size.height;

            //var PercentWidth = Math.round(($(event.target).width()*100)/$(event.target).parent().width());
            var PercentWidth = ui.size.width;
            if (
                $(event.target).get(0).tagName.toLowerCase() == 'td' ||
                $(event.target).get(0).tagName.toLowerCase() == 'th'
            ) {
                $(event.target).parent().attr('height', height);
                $(event.target).parent().find('.ui-resizable-e').height(height);
                $(event.target)
                    .parent()
                    .parent()
                    .find('tr')
                    .eq(0)
                    .find('th,td')
                    .eq($(event.target).index())
                    .attr({
                        width: width,
                    });
            } else if (
                $(event.target).get(0).tagName.toLowerCase() == 'table'
            ) {
                console.log('table->' + PercentWidth);
                parent.$('#tableWidth').val(PercentWidth);
                parent.$('.tableWidthPX dt a span').html('px');
                $(event.target).attr({ width: width, height: height });
            } else {
                $(event.target).attr({ width: width, height: height });
            }
            $(event.target).css({ width: '', height: '' });
            if (
                $(event.target).attr('style') != undefined &&
                $(event.target).attr('style') == ''
            ) {
                $(event.target).removeAttr('style');
            }
        },
        stop: function (event, ui) {
            var PercentWidth =
                Math.round(
                    ($(event.target).width() * 100) /
                        $(event.target).parent().width()
                ) + 'px';
            PercentWidth = $(event.target).width();
            //$(event.target).css("width",PercentWidth);
            $(event.target).attr('width', PercentWidth);
            /*
                 if($.browser.mozilla) {
                     $('td').each(function(){
                         $(this).find('.ui-resizable-e').css({
                                  height:$(this).height()
                                  ,left:$(this).width()+$(this).position().left
                                  ,top:$(this).position().top
                              });
                         $(this).find('.ui-resizable-s').css({
                                 width:$(this).width()
                                  ,height:'10px'
                                  ,left:$(this).position().left
                                  ,top:$(this).height()+$(this).position().top
                              });

                     })
                 }
                  */
        },
    };
    RVwys.resizeTable = function () {
        var newRangeParent = RVwys.getRangeParent();
        var thisTable = RVwys.getParentTable(newRangeParent, 'table');
        thisTable
            .resizable(this.resizeObject)
            .find('th,td')
            .each(function () {
                $(this).resizable(RVwys.resizeObject);
            });
        //$('td, table').find('.ui-icon').hide();
    };

    RVwys.unresizeTable = function () {
        //try{$(this.opts.target).find('td,table').resizable("destroy");}catch(e){}
        //$(RVwys.currentiFrame)
        $(RVwys.currentiFrame)
            .find('td,table')
            .each(function () {
                if ($(this).hasClass('ui-resizable')) {
                    $(this).resizable('destroy');
                }
            });
    };

    RVwys.unsetTableMode = function (obj) {
        try {
            obj.find('table').each(function () {
                if ($(this).hasClass('ui-selectable')) {
                    $(this)
                        .selectable('destroy')
                        .find('.ui-selected')
                        .removeClass('ui-selected');
                }
            });
        } catch (e) {
            console.log(e);
        }
        try {
            obj.find('tr').each(function () {
                $(this).sortable('destroy');
            });
        } catch (e) {
            console.log(e);
        }
        try {
            obj.find('td,table').each(function () {
                if ($(this).hasClass('ui-resizable'))
                    $(this).resizable('destroy');
                $(this).sortable('destroy');
            });
        } catch (e) {
            console.log(e);
        }
    };

    RVwys.selectableDisableState = function (opt) {
        RVwys.selectableEnableState();
        parent.$('.accordionInsert').addClass('ui-state-disabled');
        parent.$('.toolLink').addClass('ui-state-disabled');
        parent.$('.toolInsert').addClass('ui-state-disabled');
        parent.$('.mini_htmlModeSource').addClass('ui-state-disabled');
    };
    RVwys.selectableEnableState = function (opt) {
        parent.$('.accordionInsert').removeClass('ui-state-disabled');
        parent.$('.toolLink').removeClass('ui-state-disabled');
        parent.$('.toolInsert').removeClass('ui-state-disabled');
        parent.$('.mini_htmlModeSource').removeClass('ui-state-disabled');
    };

    RVwys.selectable = function (opt) {
        this.resizeTable();
        /*
     if(!$.browser.mozilla) {
     this.resizeTable();
     }
 */
        var newRangeParent = RVwys.getRangeParent();

        var thisTable = RVwys.getParentTable(newRangeParent, 'table');
        $('.ui-selecting').removeClass('ui-selecting');
        var sTable = thisTable.selectable({
            filter: 'td',
            create: function (event, ui) {
                RVwys.regisTable();
                var rangeParent = RVwys.getRangeParent();
                $(event.target).find('th,td').eq(0).addClass('ui-selected');
                RVwys.currentRangeTable = rangeParent;
                RVwys.selectableDisableState();
            },
            stop: function (event, ui) {
                $(event.target).removeAttr('startcol');
                $(event.target).removeAttr('endcol');
                $(event.target).removeAttr('indextr');
                $(event.target).removeAttr('indextd');
                $('.ui-setselecting').each(function () {
                    $(this)
                        .removeClass('ui-setselecting')
                        .addClass('ui-selected');
                });
                $('.ui-selectee').unbind('mouseover');
                var rangeParent = $(this).find('.ui-selected', this).last();
                RVwys.currentRangeTable = rangeParent;
                parent.RVwys.currentRangeTable = rangeParent;
            },
            start: function (event, ui) {
                indexStartTD = 99999;
                indexEndTD = 0;
                indexStartTR = 99999;
                indexEndTR = 1;
            },
            selected: function (event, ui) {
                RVwys.tableActiveToolbar($(event.target));
                // parent.RVwys.showPanelAll();
                parent.$('.dtbartext').hide();
            },

            selecting: function (event, ui) {
                //parent.RVwys.showPanelAll();
                parent.$('.dtbartext').hide();

                RVwys.reSelectingTable(event, ui);
                $('.ui-selectee').bind('mouseover', function (event) {
                    var sel = RVwys.currentEditor.getSelection();
                    sel.removeAllRanges();
                    var newSel = RVwys.currentEditor.createRange();
                    newSel.setStartBefore($(event.target).get(0));
                    sel.addRange(newSel);
                });
            },

            unselecting: function (event, ui) {
                RVwys.reSelectingTable(event, ui);
            },
        });

        sTable.find('.ui-selectee').attr({
            designMode: 'On',
            contentEditable: 'true',
        });
        RVwys.statusSelectMode();
    };

    RVwys.unselectable = function () {
        this.unresizeTable();

        $(this.opts.target)
            .find('table')
            .each(function () {
                if ($(this).hasClass('ui-selectable')) {
                    $(this).selectable('destroy');
                }
            })
            .end()
            .find('.ui-selected')
            .removeClass('ui-selected')
            .end()
            .find('.ui-selectee')
            .removeClass('ui-selectee');
        RVwys.unregisTable();
        $('.ui-selectee').unbind('mouseover');
        // $('td,table').resizable('destroy')
    };
    $(document).bind('editorClose', function () {
        frameBody = $('#frameBody').get(0);
        RVwys.unselectable();
        RVwys.unsortable();
        $('.ui-sortable').removeClass('ui-sortable');

        $('#styleTable').remove();
    });
})(jQuery);
